import React from 'react';
import API from '../api';
const CsrfTokenContext = React.createContext({
    refreshCsrfToken: undefined,
    csrfToken: '',
    error: undefined,
});
function CsrfTokenProvider({ children }) {
    const [csrfToken, setCsrfToken] = React.useState('');
    const [error, setError] = React.useState();
    const refreshCsrfToken = React.useCallback(async () => {
        try {
            const r = await API.Security.getCsrfToken();
            setCsrfToken(r.csrfToken);
        }
        catch (e) {
            console.error(e);
            setError(e);
        }
    }, []);
    React.useEffect(() => {
        (async () => await refreshCsrfToken())();
    }, [refreshCsrfToken]);
    const provided = { refreshCsrfToken, csrfToken, error };
    return React.createElement(CsrfTokenContext.Provider, { value: provided }, children);
}
export { CsrfTokenContext, CsrfTokenProvider };
